import resolveDefaultProps from "utils/resolveDefaultProps";
import React, { forwardRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const TBody = forwardRef((props, ref) => {
  props = resolveDefaultProps(props, TBodyDefaults);

	const { children, className, asElement: Component, ...rest } = props

	const tBodyClass = classNames(
		Component !== 'tbody' && 'tbody',
		className
	)

	return (
		<Component className={tBodyClass} {...rest} ref={ref}>
			{children}
		</Component>
	)
})

TBody.propTypes = {
	asElement: PropTypes.string
};

const TBodyDefaults = {
	asElement: 'tbody'
}

export default TBody
